<template lang="pug">
  .building
    Producer(v-if="cell.config.type === 'mining'" :info="cell")
    Storage(v-else-if="cell.config.type === 'storage'" :info="cell")
    Producer(v-else :info="cell")
</template>

<script>

import buildings from '@/components/buildings'

export default {
  name: 'Building',
  props: [ 'cell' ],
  components: { ...buildings }
}
</script>

<style lang="scss" scoped>
.building {
  > div {
    height: 74px;

  .name {
    font-size: 8px;
    line-height: 8px;
    font-weight: 700;
    padding-top: 4px;
    padding-bottom: 4px;

  .provides,.stores {
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      .amount {
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;

        &.negative {
          color: #d80c0c;

        }
      }
    }
  }
  }
  }
}</style>



// WEBPACK FOOTER //
// src/components/Building.vue